import { render, staticRenderFns } from "./cell.vue?vue&type=template&id=52b62865&scoped=true&"
import script from "./cell.vue?vue&type=script&lang=ts&"
export * from "./cell.vue?vue&type=script&lang=ts&"
import style0 from "./cell.vue?vue&type=style&index=0&id=52b62865&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b62865",
  null
  
)

export default component.exports